<template>
  <div class="game-hub">
    <!-- 顶部标题栏 -->
    <div class="header">
      <h1>主菜单</h1>
    </div>

    <!-- 动态菜单列表 -->
    <div class="game-list-container">
      <ul class="game-list">
        <li
          class="game-item"
          v-for="(menu, index) in menuItems"
          :key="index"
          @click="navigateTo(menu.path)"
        >
          <h2>{{ menu.title }}</h2>
          <p>{{ menu.description }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainMenu",
  data() {
    return {
      menuItems: [
        { title: "背包", description: "管理你的物品和道具", path: "/pve" },
        { title: "地图", description: "探索未知的世界", path: "/galaxy-map" },
        { title: "宝可梦图鉴", description: "查看已收集的宝可梦", path: "/pokedex" },
        { title: "训练师中心", description: "与其他玩家互动", path: "/trainer-center" },
        { title: "竞技场", description: "参与激烈的战斗", path: "/arena" },
        { title: "商店", description: "购买稀有道具和物品", path: "/shop" },
				{ title: "技能回忆", description: "唤醒宝可梦遗忘的技能", path: "/movememory" },
        { title: "翻卡游戏", description: "玩游戏获得大量金币", path: "/flipgame" },
        { title: "进化仓", description: "查看并手动进化宝可梦", path: "/evolutionchamber" }, 
      ],
    };
  },
  methods: {
    navigateTo(path) {
      this.$router.push(path); // 跳转到对应的路由
    },
  },
};
</script>

<style scoped>
/* 主容器 */
.game-hub {
  background-color: #f0f0f0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  color: #333; /* 深色字体 */
}

/* 顶部标题栏样式 */
.header {
  background-color: #4caf50;
  color: #fff; /* 白色字体 */
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.header h1 {
  margin: 0;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
}

/* 菜单列表容器 */
.game-list-container {
  flex: 1;
  overflow-y: auto; /* 启用垂直滚动 */
  padding: 20px;
}

/* 美化滚动条 */
.game-list-container::-webkit-scrollbar {
  width: 8px;
}

.game-list-container::-webkit-scrollbar-thumb {
  background: #4caf50;
  border-radius: 4px;
}

.game-list-container::-webkit-scrollbar-track {
  background: #ddd;
  border-radius: 4px;
}

/* 菜单项 */
.game-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 15px; /* 间距 */
}

.game-item {
  background: #fff; /* 默认白色背景 */
  border: 1px solid #ddd; /* 边框 */
  border-radius: 8px; /* 圆角 */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* 卡片阴影 */
  padding: 20px;
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s;
}

.game-item:hover {
  transform: translateY(-5px); /* 鼠标悬浮时上移 */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* 鼠标悬浮时阴影增强 */
}

.game-item h2 {
  margin: 0 0 10px 0;
  font-size: 20px;
  color: #007bff; /* 蓝色标题 */
}

.game-item p {
  margin: 0;
  font-size: 14px;
  color: #666;
}
</style>
